// The Resources menu, for the header and the footer. Names and paths only, so
// the header doesn't load guide copy. docs/refresh/COPY_DECK.md "Guides ›
// Changes to existing pages and navigation" and "Compare › Changes to
// existing pages and navigation". A link with a gate shows only while its
// page gate is on (content/gates.js).

import { gated } from '../gates';

export const RESOURCES_MENU = 'Resources';

export const RESOURCE_LINKS = gated([
  { label: 'Guides', to: '/guides' },
  { label: 'Due Diligence Checklist', to: '/guides/due-diligence-checklist' },
  { label: 'Glossary', to: '/glossary' },
  { label: 'Compare Data Rooms', to: '/compare', gate: 'L1' },
]);

// The menu's links count as one section for the header's active underline.
export const isResourcesPath = (pathname) =>
  pathname === '/guides' ||
  pathname.startsWith('/guides/') ||
  pathname === '/glossary' ||
  pathname === '/compare' ||
  pathname.startsWith('/compare/');
